import { configureStore } from '@reduxjs/toolkit';
import answerReducer from './answerSlice';
import reportReducer from "./reportSlice";
import applyOpportunityReducer from "./applyOpportunitySlice";
import certificatedetailReducer from "./certificatedetailSlice";
import profiledetailReducer from './profiledetailSlice';
import paymentdetailReducer from "./paymentdetailSlice";
import idproofReducer from "./idproofSlice";
import profileadditionalinfoReducer from "./profileadditionalinfoSlice";
import notificationReducer from "./notificationSlice";

export const store = configureStore({
  reducer: {
    answers: answerReducer,
    reports: reportReducer,
    applyopportunities: applyOpportunityReducer,
    certificatedetails: certificatedetailReducer,
    profiledetails: profiledetailReducer,
    paymentdetails: paymentdetailReducer,
    idproofs: idproofReducer,
    profileadditionalinfos: profileadditionalinfoReducer,
    notification: notificationReducer,
  },
});
